export default "__VITE_ASSET__be88c29a__"